<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：资金池详情
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input size="small" v-model="searchForm.user_id" placeholder="请输入用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="success" @click="onExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="funds_pool_log_id" label="ID" width="50"></el-table-column>
          <el-table-column prop="user_id" label="用户ID">
            <template slot-scope="{row}">
              <p>{{ row.user_id }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="scene_text" label="资金池变动场景"></el-table-column>
          <el-table-column prop="money" label="变动金额"></el-table-column>
          <el-table-column prop="current_money" label="余额"></el-table-column>
          <el-table-column prop="describe" label="描述/说明"></el-table-column>
          <el-table-column prop="order_id" label="关联订单ID"></el-table-column>
          <el-table-column prop="create_time" label="创建时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="pagingObj.page" :page-size="pagingObj.list_rows" :page-sizes="[5, 10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="pagingObj.totalDataNumber"></el-pagination>
      </div>
    </div>
    <div class="mt50"></div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="$router.back(-1);">返回上一页</el-button>
    </div>
  </div>
</template>

<script>
import UserApi from '@/api/user.js'
import qs from 'qs'
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      // 分页对象
      pagingObj: {
        /*一页多少条*/
        list_rows: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        page: 1,
      },
      /*横向表单数据模型*/
      searchForm: {
        user_id: '',
        // 资金池ID
        funds_pool_id: '',
      },
    }
  },
  created() {
    this.searchForm.funds_pool_id = this.$route.query.funds_pool_id
    if (!this.searchForm.funds_pool_id) {
      this.$message.error('请提供资金池ID')
      return
    }
    /*获取列表*/
    this.getData()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.pagingObj.page = val
      self.getData()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pagingObj.page = 1
      this.pagingObj.list_rows = val
      this.getData()
    },
    /*切换菜单*/
    handleClick(tab, event) {
      let self = this
      self.pagingObj.page = 1
      self.getData()
    },
    /*获取列表*/
    getData() {
      let self = this
      self.loading = true
      UserApi.fundsPoolLog(Object.assign({}, self.searchForm, self.pagingObj))
        .then(res => {
          self.tableData = res.data.list.data
          self.pagingObj.totalDataNumber = res.data.list.total
          self.loading = false
        })
        .catch(error => {})
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1
      this.tableData = []
      this.getData()
    },
    /*选择*/
    handleSelectionChange(e) {
      this.multipleSelection = e
    },
    /*导出*/
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/user.FundsPoolLog/export?' + qs.stringify(this.searchForm);
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/fundpool/detail.vue